<template>
    <div class="block">
      <!-- Logo block with link back to home page. -->
      <router-link to="/home" custom v-slot="{ navigate }">
        <button class="logo_block" @click="navigate" role="link">
          <img src="@/assets/logo_huashihongfeng_69.png"  alt="huasTrade Logo">
          <div style="width: 100px; color: beige; font-weight: bolder; font-size: xx-large; padding-left: 0.5%;">huasT</div>
        </button>
      </router-link>
        
      <!-- Menu blocks with link to respective page. -->
      <div style="flex: 1px"></div>
      <router-link to="/home" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">首页</button>
      </router-link>     
      <div style="flex: 1px"></div> 
      <router-link to="/DataView" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">写策略</button>
      </router-link>
      <div style="flex: 1px"></div>
      <router-link to="/Strategies" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">策略榜</button>
      </router-link>
      <div style="flex: 1px"></div>
      <router-link to="/strategiesViewsContainer" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">量能榜</button>
      </router-link>      
      <div style="flex: 1px"></div>
      <router-link to="/HuasTrade" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">交易端</button>
      </router-link>      
      <div style="flex: 1px"></div>      
      <router-link to="/community" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">社群区</button>
      </router-link>
      <div style="flex: 1px"></div>
      <router-link to="/TestTable" custom v-slot="{ navigate }">
        <button class="menu_block" @click="navigate" role="link">帮助中心</button>
      </router-link>
  
      <div style="flex: 1px"></div>
  
      <!-- Search UI component -->
      <div class="search">
          <input id="search_head" type="text" class="search__input" placeholder="Search">
          <button class="search__button">
              <svg class="search__icon" aria-hidden="false" viewBox="0 0 20 20">
                  <g>
                      <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                  </g>
              </svg>
          </button>
      </div>
  
      <!-- Login block -->
             <router-link to="/login" custom v-slot="{ navigate }">
      <div style="width: 100px; color: antiquewhite">LOGIN</div>
            </router-link>
    </div>
  </template>
  
  <script>   
  export default {
      name: "Header"
  }
  </script>
  
  <style scoped>  
  .block {
    height: 69px;
    line-height: 69px;
    background-color: #7560fc;
    display: flex;
  }
  
  .logo_block {
    display: flex;
    height: 69px;
    line-height: 69px;
    width: 300px;
    padding-top: 10px;
    padding-left: 50px;
    background-color: #7560fc;
    border:#7560fc
  }
  
  img {
    display: inline-block;
    
    height: 95%;
    width: auto;
    filter:brightness(125%);
  }
  
  .menu_block {
    width: 160px; 
    color: beige;
    font-size: large;
    background-color: #7560fc;
    border:#7560fc
  }
  
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    padding-right: 5%;
  }
  
  .search__input {
    font-family: inherit;
    font-size: inherit;
    background-color: #f4f2f2;
    border: none;
    color: #646464;
    padding: 0.7rem 1rem;
    border-radius: 30px;
    width: 11em;
    height: 30px;
    transition: all ease-in-out .5s;
    margin-right: -2rem;
  }
  
  .search__input:hover, .search__input:focus {
    box-shadow: 0 0 1em #00000013;
  }
  
  .search__input:focus {
    outline: none;
    background-color: #f0eeee;
  }
  
  .search__input::-webkit-input-placeholder {
    font-weight: 100;
    color: #ccc;
  }
  
  .search__input:focus + .search__button {
    background-color: #f0eeee;
  }
  
  .search__button {
    border: none;
    height: 25px;
    background-color: #f4f2f2;
    margin-top: -2.5em;
  }
  
  .search__button:hover {
    cursor: pointer;
  }
  
  .search__icon {
    height: 20px;
    width: 20px;
    margin-top: -2.5em;
    fill: #b4b4b4;
  }
  </style>